import { FaHospitalUser, FaThLarge } from "react-icons/fa";
/* eslint-disable react-hooks/rules-of-hooks */
import { AiFillSetting } from "react-icons/ai";
import { FiLogOut } from "react-icons/fi";
import { RiLockPasswordLine } from "react-icons/ri";
import {
  Flex,
  IconButton,
  useColorModeValue,
  Text,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  Box,
  Avatar,
  Image,
  useColorMode,
  Divider,
  Input,
  VStack,
  Button,
  useDisclosure,
  Tooltip,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import { FiSun, FiMoon, FiUser } from "react-icons/fi";
import { useLocation, useNavigate } from "react-router-dom";
import admin from "../Controllers/admin";
import NotificationIcon from "../Components/Notification";
import UpdateAdminPassword from "../Components/UpdatePassword";
import useSettingsData from "../Hooks/SettingData";
import { imgUrl } from "../Controllers/image";
import useHasPermission from "../Hooks/HasPermission";
import Logout from "../Controllers/logout";
import UseClinicsData from "../Hooks/UseClinicsData";
import { useSelectedClinic } from "../Context/SelectedClinic";
import { motion } from "framer-motion";
import { LanguageSelector } from "./LanguageSelector";
import { useTranslation } from "react-i18next";
import FullscreenToggle from "./FullScreenToggler";

export default function Topbar() {
  const { colorMode, toggleColorMode } = useColorMode();
  const Uselocation = useLocation();
  const location = Uselocation.pathname.split("/")[1];
  const { isOpen, onOpen, onClose } = useDisclosure();
  const navigate = useNavigate();
  const { settingsData } = useSettingsData();
  const { hasPermission } = useHasPermission();
  const { t } = useTranslation();

  useEffect(() => {
    colorMode === "dark"
      ? document.body.classList.add("dark")
      : document.body.classList.remove("dark");
  }, [colorMode]);

  // update  user
  const logo = settingsData?.find((value) => value.id_name === "logo");
  const baseUrlWithSlash = import.meta.env.BASE_URL.endsWith("/")
    ? import.meta.env.BASE_URL
    : `${import.meta.env.BASE_URL}/`;
  const defaultLogo = `${baseUrlWithSlash}logo.png`;
  const defaultAvatar = `${baseUrlWithSlash}imagePlaceholder.png`;


  const logoSrc = logo?.value ? imgUrl(logo.value) : defaultLogo;

  const adminImageSrc = admin?.image ? imgUrl(admin.image) : defaultAvatar;

  const { selectedClinic } = useSelectedClinic();
  const capitalizedLocation = location
    .replace(/-/g, " ") // replace "-" with space
    .replace(/\b\w/g, (char) => char.toUpperCase()); // capitalize each word

  return (
    <Flex
      as="header"
      align="center"
      justify="space-between"
      px="4"
      py="2"
      bg={useColorModeValue("white", "gray.800")}
      boxShadow="none"
      zIndex="sticky"
      top="0"
      position={"sticky"}
      borderBottom={"1px solid"}
      borderColor={useColorModeValue("gray.200", "gray.600")}
    >
      <Box display={"flex"} alignItems={"center"} gap={5}>
        {" "}
        <Image
          w={16}
          src={logoSrc}
          filter={useColorModeValue("none", "invert(1)")}
          onError={(e) => {
            e.currentTarget.src = defaultLogo;
          }}
        />
        <Box h={8} bg={"gray.500"} p={"1px"}></Box>
        <Text
          fontSize="xl"
          fontWeight="500"
          mb={0}
          textTransform={"capitalize"}
        >
          {t(capitalizedLocation)}
        </Text>
      </Box>

      <Flex align={"center"}>
        <ClinicSelctor />
        <NotificationIcon />
        <Tooltip label={t("shortcuts.quickUtilities")} placement="bottom">
          <IconButton
            icon={<FaThLarge />}
            aria-label="Open Utilities"
            variant="ghost"
            colorScheme="black"
            size="sm"
            onClick={() => {
              navigate("shortcut");
            }}
          />
        </Tooltip>
        <IconButton
          aria-label="Toggle color mode"
          icon={colorMode === "light" ? <FiMoon /> : <FiSun />}
          onClick={() => {
            toggleColorMode();
            colorMode === "light"
              ? document.body.classList.add("dark")
              : document.body.classList.remove("dark");
          }}
          variant="ghost"
          colorScheme="black"
          size={"sm"}
        />{" "}
        <Menu>
          <MenuButton
            as={IconButton}
            variant="ghost"
            colorScheme="black"
            icon={<FiUser />}
            size={"sm"}
          />

          <MenuList>
            <Box p={2} w={300}>
              <Flex justify={"center"}>
                <Avatar
                  src={adminImageSrc}
                  name={`${admin?.f_name || ""} ${admin?.l_name || ""}`.trim()}
                  w={16}
                />
              </Flex>
              <Text textAlign={"center"} mt={2} fontSize={"lg"}>
                {admin.f_name} {admin.l_name}
              </Text>
              <Text textAlign={"center"} fontSize={"md"} fontWeight={600}>
                {admin.role.name}
              </Text>
            </Box>
            <Divider mb={3} />
            <MenuItem
              onClick={() => {
                admin.role.name.toLowerCase() === "doctor"
                  ? navigate(`/doctor/profile`)
                  : admin.role.name.toLowerCase() === "clinic"
                  ? navigate(`/clinic/self/profile/update/${admin.clinic_id}`)
                  : navigate(`/user/update/${admin.id}`);
              }}
              icon={<FiUser />}
            >
              {t("topbarMenu.account")}
            </MenuItem>
            {hasPermission("CLINIC_UPDATE") &&
              admin.role.name.toLowerCase() === "clinic" && (
                <MenuItem
                  onClick={() => {
                    navigate(
                      `/clinic/self/profile/update/${
                        selectedClinic ? selectedClinic.id : admin.clinic_id
                      }`
                    );
                  }}
                  icon={<FaHospitalUser />}
                >
                  {t("topbarMenu.clinicDetails")}
                </MenuItem>
              )}

            <MenuItem onClick={onOpen} icon={<RiLockPasswordLine />}>
              {t("topbarMenu.changePassword")}
            </MenuItem>
            {hasPermission("SETTING_VIEW") && (
              <MenuItem
                onClick={() => {
                  navigate("/settings");
                }}
                icon={<AiFillSetting />}
              >
                {t("topbarMenu.settings")}
              </MenuItem>
            )}

            <MenuItem
              icon={<FiLogOut />}
              onClick={() => {
                Logout();
              }}
            >
              {t("topbarMenu.logout")}
            </MenuItem>
          </MenuList>
        </Menu>
        <LanguageSelector />
        <FullscreenToggle />
      </Flex>

      <UpdateAdminPassword isOpen={isOpen} onClose={onClose} />
    </Flex>
  );
}


const ClinicSelctor = () => {
  const [search, setSearch] = useState("");
  const { clinicsLoading } = UseClinicsData();
  const { selectedClinic, setSelectedClinic, allowedClinics } = useSelectedClinic();

  // Llamar hooks SIEMPRE al inicio del componente (Rules of Hooks). Antes
  // estaban dentro del .map() de MenuItem, lo que rompía el orden de hooks
  // y el onClick handler nunca disparaba el setSelectedClinic. Bug F4
  // detectado 2026-05-15.
  const highlightBg = useColorModeValue("gray.100", "gray.600");

  const roleName = String(admin?.role?.name || "").toLowerCase();
  const isDoctor = roleName === "doctor";
  const isClinic = roleName === "clinic";
  const isSuperAdmin = roleName === "super admin";

  const filteredClinics = (allowedClinics || []).filter((clinic) => {
    if (!search) return true;

    const query = search.toLowerCase();
    const searchableFields = [
      clinic.title,
      clinic.address,
      clinic.city_title,
      clinic.state_title,
      clinic.description,
      String(clinic.id),
    ];

    return searchableFields.some(
      (field) => field && String(field).toLowerCase().includes(query)
    );
  });

  const canChangeClinic = isSuperAdmin || isDoctor;
  const shouldShowSelector =
    isSuperAdmin || isDoctor || isClinic || !!selectedClinic;

  if (!shouldShowSelector) return null;

  return (
    <VStack spacing={4} align="start">
      <Menu>
        <Flex align={"center"} gap={2}>
          <Text fontWeight={400} fontSize={"sm"}>
            Clinic -
          </Text>

          <MenuButton
            as={Button}
            leftIcon={<FaHospitalUser />}
            size={"xs"}
            bg={"none"}
            border={"1px solid"}
            borderColor={"gray.300"}
            isDisabled={!canChangeClinic}
            _hover={{ bg: "none" }}
            _active={{ bg: "none" }}
            _disabled={{ cursor: "not-allowed" }}
          >
            {clinicsLoading ? (
              <Flex>
                Loading
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1, repeat: Infinity, delay: 0.2 }}
                >
                  .
                </motion.span>
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1, repeat: Infinity, delay: 0.4 }}
                >
                  .
                </motion.span>
                <motion.span
                  animate={{ opacity: [0, 1, 0] }}
                  transition={{ duration: 1, repeat: Infinity, delay: 0.6 }}
                >
                  .
                </motion.span>
              </Flex>
            ) : selectedClinic ? (
              selectedClinic.title
            ) : (
              "All"
            )}
          </MenuButton>
        </Flex>

        <MenuList
          maxW={"500px"}
          minW={"300px"}
          zIndex={100}
          maxH={"70vh"}
          overflow={"auto"}
        >
          <Box p={2}>
            <Input
              placeholder="Search clinics..."
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              size="md"
              isDisabled={!canChangeClinic}
            />
          </Box>

          {filteredClinics?.length > 0 ? (
            filteredClinics.map((clinic) => (
              <MenuItem
                key={String(clinic?.id)}
                onClick={() => {
                  if (!canChangeClinic) return;
                  setSelectedClinic(clinic);
                  setSearch("");
                }}
                bg={
                  String(selectedClinic?.id) === String(clinic?.id)
                    ? highlightBg
                    : "initial"
                }
                _hover={{ bg: highlightBg }}
                fontSize={"md"}
              >
                {String(clinic?.id) === "all"
                  ? "All"
                  : `${clinic.title}${
                      clinic.city_title ? ` - ${clinic.city_title}` : ""
                    }${clinic.state_title ? `, ${clinic.state_title}` : ""} - #${clinic.id}`}
              </MenuItem>
            ))
          ) : (
            <Box p={2} textAlign="center" color="gray.500">
              No results found
            </Box>
          )}
        </MenuList>
      </Menu>
    </VStack>
  );
};